import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "17",
  viewBox: "0 0 22 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M22 6.20998C22.0494 4.77864 21.7364 3.358 21.09 2.07998C20.6514 1.55558 20.0427 1.20169 19.37 1.07998C16.5875 0.827509 13.7935 0.724028 11 0.769984C8.21664 0.721942 5.4327 0.822084 2.66 1.06998C2.11182 1.1697 1.60451 1.42683 1.2 1.80998C0.299996 2.63998 0.199996 4.05998 0.0999963 5.25998C-0.0450916 7.41755 -0.0450916 9.58242 0.0999963 11.74C0.128927 12.4154 0.22949 13.0858 0.399996 13.74C0.520571 14.245 0.764519 14.7123 1.11 15.1C1.51726 15.5034 2.03638 15.7752 2.6 15.88C4.75591 16.1461 6.92821 16.2564 9.1 16.21C12.6 16.26 15.67 16.21 19.3 15.93C19.8775 15.8316 20.4112 15.5595 20.83 15.15C21.11 14.8699 21.3191 14.5271 21.44 14.15C21.7976 13.0526 21.9733 11.9041 21.96 10.75C22 10.19 22 6.80998 22 6.20998ZM8.74 11.35V5.15998L14.66 8.26998C13 9.18998 10.81 10.23 8.74 11.35Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }